export { LandingPageQuote } from "./LandingPageQuote";
